import tabNavigation from '../../../../../../src/js/modules/tabNavigation';
import elementStateToggle from '../../../../../../src/js/modules/elementStateToggle';
import sliderTabNavigation from '../../../../../../src/js/modules/sliderTabNavigation';

window.addEventListener('load', () => {
    tabNavigation.init();
    sliderTabNavigation.init();
    elementStateToggle.init({
        preventDefault: true,
        hasContextElement: {
            elements: '.js-state-context',
            attr: 'href',
        },
        toggleActiveElement: true,
    });
});
